import { SizeCode } from 'entities/SizeCode';
import { Warehouse } from 'entities/Warehouse';
import { StepData, stepsMapper } from 'features/Stepper';

export enum ChangePricesSteps {
  SELECT_WAREHOUSE = 'Select a Warehouse',
  SELECT_SIZES = 'Select sizes',
  CHANGE_PRICES = 'Change prices',
}

export enum PriceChangeDirection {
  INCREASE = 'increase',
  DECREASE = 'decrease',
}

export enum RateType {
  DAILY_RATE = 'dailyRate',
  WEEK_RATE = 'weekRate',
  MONTH_RATE = 'monthRate',
}

export const DEFAULT_RATE_TYPES = [RateType.WEEK_RATE, RateType.MONTH_RATE];

export const changePricesSteps = stepsMapper([...Object.values(ChangePricesSteps)]);

export interface PriceChangeParams {
  direction: PriceChangeDirection;
  percent: Nullable<number>;
  rateTypes: RateType[];
}

export interface ChangePricesModalSchema {
  isOpened: boolean;
  steps: StepData[];
  selectedWarehouse: Nullable<Warehouse>;
  selectedSizeCodes: SizeCode[];
  priceChangeParams: PriceChangeParams;
}
